import { Icon } from '../icon';
import { Typography } from '../typography';
import clsx from 'clsx';
import { UploadContainer } from '../upload';

interface UploadButtonProps {
	buttonLabel: string;
	disabled?: boolean;
	buttonIcons?: string;
	file?: File;
	setFile: (value: File) => void;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
	disabled,
	buttonIcons,
	buttonLabel,
	setFile,
}) => {
	return (
		<>
			<UploadContainer id="documentacion" setFile={setFile} disabled={disabled}>
				<div
					className={clsx(
						'flex items-center w-fit cursor-pointer border border-green-base py-[14px] px-6 rounded-full',
						{
							'cursor-not-allowed pointer-events-none bg-white border-opacity-20':
								disabled,
						}
					)}
				>
					<span
						className={clsx(
							'w-4 h-4 mr-2',
							disabled ? 'text-[#97949A]' : 'text-black'
						)}
					>
						<Icon
							src={buttonIcons || ''}
							className={clsx(
								'w-4 h-4',
								disabled ? 'text-[#97949A]' : 'text-black'
							)}
						/>
					</span>
					<Typography
						type="semibold-16"
						className={clsx(disabled ? '!text-[#97949A]' : 'text-black')}
					>
						{buttonLabel}
					</Typography>{' '}
				</div>
			</UploadContainer>
		</>
	);
};
